module.exports = __webpack_public_path__ + "img/info-warning.a75645b0.svg";